import CmpNumberInput from "./CmpNumberInput";

export default CmpNumberInput;